import react, { useState, useEffect } from 'react';
import { getAuth } from 'firebase/auth';
import { loadStripe } from '@stripe/stripe-js';
import { Elements, CardElement, useStripe, useElements } from '@stripe/react-stripe-js';
import Stripe from 'stripe';
import '../Styles/paymentMethodStyle.css';

function PaymentMethods() {
    const stripe = useStripe();
    const elements = useElements();
    const [editCard, setEditCard] = useState(null);

    const auth = getAuth();
    const user = auth.currentUser;

    const [stripePromise, setStripePromise] = useState(null);
    const [clientSecret, setClientSecret] = useState("");
    const [cards, setCards] = useState([]);
    const [openMenuIndex, setOpenMenuIndex] = useState(null);
    const [setupNewPayMethod, setSetupNewPayMethod] = useState(false);
    const [step, setStep] = useState('1');
    const [deleteConfirm, setDeleteConfirm] = useState(false);
    const [newCardDetails, setNewCardDetails] = useState({
        cardNumber: '',
        expiration: '',
        cvv: '',
        nameOnCard: '',
        country: '',
        addressLine1: '',
        addressLine2: '',
        city: '',
        postCode: '',
        stateOrRegion: '',
    });
    const [cardToDelete, setCardToDelete] = useState(null);

    useEffect(() => {
        fetch("/config").then(async (r) => {
            const { publishableKey } = await r.json();
            setStripePromise(loadStripe(publishableKey));
            console.log(publishableKey);
        });
        fetchPaymentMethods();
    }, []);

    const fetchCustomerId = async (email) => {
        try {
            const response = await fetch("https://mmp3cpgdp3.eu-west-2.awsapprunner.com/get-customer-id", {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ email }),
            });

            const data = await response.json();
            console.log(data.customerId)
            return data.customerId; // Assuming your endpoint returns the customer ID in this format
        } catch (error) {
            console.error('Error fetching customer ID:', error);
            // Handle error (show error message, etc.)
        }
    };

    //function to fetch payment methods
    const fetchPaymentMethods = async () => {
        try {
            // Fetch the customer ID using the user's email
            const customerId = await fetchCustomerId(user.email);
            if (!customerId) {
                console.error('Customer ID not found');
                return;
            }

            // Fetch payment methods
            const response = await fetch("https://mmp3cpgdp3.eu-west-2.awsapprunner.com/get-payment-methods", {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ customerId }),
            });

            const data = await response.json();
            const paymentMethods = data.paymentMethods;
            const defaultSourceId = data.defaultSource;

            console.log(data.paymentMethods);
            console.log("default method: ", data.defaultSource);

            // Update the cards state to mark the default payment method
            setCards(paymentMethods.map(card => ({
                ...card,
                isDefault: card.id === defaultSourceId,
            })));
        } catch (error) {
            console.error('Error fetching payment methods:', error);
            // Handle error (show error message, etc.)
        }
    };

    const handleUpdateCard = async () => {
        try {
            if (!stripe || !elements) {
                console.error('Stripe.js has not loaded yet.');
                return;
            }

            const cardElement = elements.getElement(CardElement);
            const customerId = await fetchCustomerId(user.email);

            const { error, paymentMethod } = await stripe.createPaymentMethod({
                type: 'card',
                card: cardElement,
            });

            if (error) {
                console.error('Error creating payment method:', error);
                return;
            }

            const response = await fetch('https://mmp3cpgdp3.eu-west-2.awsapprunner.com/update-payment-method', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    customerId: customerId,
                    paymentMethodId: editCard.id,
                    newPaymentMethodId: paymentMethod.id,
                }),
            });

            if (response.ok) {
                fetchPaymentMethods();
                setSetupNewPayMethod(false);
                setEditCard(null);
            } else {
                console.error('Failed to update payment method');
            }
        } catch (error) {
            console.error('Error updating payment method:', error);
        }
    };

    // Function to handle deleting payment methods
    const handleDelete = async (paymentMethodId) => {
        try {
            const customerId = await fetchCustomerId(user.email);
            if (!customerId) {
                console.error('Customer ID not found');
                return;
            }

            const response = await fetch('https://mmp3cpgdp3.eu-west-2.awsapprunner.com/delete-payment-method', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ paymentMethodId, customerId  }),
            });

            if (response.ok) {
                setCards((prevCards) => prevCards.filter((card) => card.id !== paymentMethodId));
                toggleDeleteConfirm();
                setCardToDelete(null);
                fetchPaymentMethods();
            } else {
                throw new Error('Failed to delete payment method');
            }
        } catch (error) {
            console.error('Error deleting payment method:', error);
        }
    };

    // Function to handle setting a payment method as primary
    const handleSetPrimary = async (paymentMethodId) => {
        try {
            const customerId = await fetchCustomerId(user.email);
            if (!customerId) {
                console.error('Customer ID not found');
                return;
            }

            const response = await fetch("https://mmp3cpgdp3.eu-west-2.awsapprunner.com/set-default-payment-method", {
                method: "POST",
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ customerId, paymentMethodId }),
            });

            if (response.ok) {
                setCards(prevCards => prevCards.map(card => ({
                    ...card,
                    isDefault: card.id === paymentMethodId,
                })));
                fetchPaymentMethods();
            } else {
                console.error('Error setting primary payment method');
            }
        } catch (error) {
            console.error('Error setting primary payment method:', error);
        }
    };

    //Add payment method to user
    const addPaymentMethod = async () => {
        try {
            if (!stripe || !elements) {
                console.error('Stripe.js has not loaded yet.');
                return;
            }

            const cardElement = elements.getElement(CardElement);
            const customerId = await fetchCustomerId(user.email);

            const { error, paymentMethod } = await stripe.createPaymentMethod({
                type: 'card',
                card: cardElement,
            });

            console.log(paymentMethod);

            if (error) {
                console.error('Error creating payment method:', error);
                return;
            }

            const response = await fetch('https://mmp3cpgdp3.eu-west-2.awsapprunner.com/create-payment-method', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    customerId: customerId,
                    paymentMethodId: paymentMethod.id,
                }),
            });

            if (response.ok) {
                fetchPaymentMethods();
                setSetupNewPayMethod(false);
            } else {
                console.error('Failed to create payment method');
            }
        } catch (error) {
            console.error('Error adding payment method:', error);
        }
    };

    // Handle card number input with formatting
    const handleCardNumberChange = (e) => {
        let value = e.target.value.replace(/\D/g, '');
        if (value.length > 16) value = value.slice(0, 16);
        const formattedValue = value.replace(/(\d{4})(?=\d)/g, '$1 ');
        setNewCardDetails((prevDetails) => ({
            ...prevDetails,
            cardNumber: formattedValue,
        }));
    };

    // Handle expiration date input with formatting
    const handleExpirationChange = (e) => {
        let value = e.target.value.replace(/\D/g, '');
        if (value.length > 4) value = value.slice(0, 4);
        const formattedValue = value.replace(/(\d{2})(?=\d)/, '$1/');
        setNewCardDetails((prevDetails) => ({
            ...prevDetails,
            expiration: formattedValue,
        }));
    };

    // Handle CVV input with limitation
    const handleCvvChange = (e) => {
        let value = e.target.value.replace(/\D/g, '');
        if (value.length > 4) value = value.slice(0, 4);
        setNewCardDetails((prevDetails) => ({
            ...prevDetails,
            cvv: value,
        }));
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setNewCardDetails((prevDetails) => ({
            ...prevDetails,
            [name]: value,
        }));
    };

    const toggleActions = (index) => {
        setOpenMenuIndex(index === openMenuIndex ? null : index);
    };

    const toggleDeleteConfirm = () => {
        setDeleteConfirm(!deleteConfirm);
    };

    const toggleNewPayMethod = () => {
        setSetupNewPayMethod(!setupNewPayMethod);
        setStep('1');
    }

    const changeStep = (newStep) => {
        setStep(newStep);
    };

    return(
        <div>
            <div className="paymentMethodsContainer">
                    <h2>Payment Methods</h2>

                <div className="methodsContainer">
                    <div className="divider"></div>
                    <div className="cardsList">
                        {cards.map((card, index) => (
                            <div key={card.id} className="cardItem">
                                <div className="cardIcon">
                                    {card.card.brand === 'visa' && <div className="svgIcon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="3.09em" height="1em" viewBox="0 0 256 83"><defs><linearGradient id="logosVisa0" x1="45.974%" x2="54.877%" y1="-2.006%" y2="100%"><stop offset="0%" stop-color="#222357" /><stop offset="100%" stop-color="#254aa5" /></linearGradient></defs><path fill="url(#logosVisa0)" d="M132.397 56.24c-.146-11.516 10.263-17.942 18.104-21.763c8.056-3.92 10.762-6.434 10.73-9.94c-.06-5.365-6.426-7.733-12.383-7.825c-10.393-.161-16.436 2.806-21.24 5.05l-3.744-17.519c4.82-2.221 13.745-4.158 23-4.243c21.725 0 35.938 10.724 36.015 27.351c.085 21.102-29.188 22.27-28.988 31.702c.069 2.86 2.798 5.912 8.778 6.688c2.96.392 11.131.692 20.395-3.574l3.636 16.95c-4.982 1.814-11.385 3.551-19.357 3.551c-20.448 0-34.83-10.87-34.946-26.428m89.241 24.968c-3.967 0-7.31-2.314-8.802-5.865L181.803 1.245h21.709l4.32 11.939h26.528l2.506-11.939H256l-16.697 79.963zm3.037-21.601l6.265-30.027h-17.158zm-118.599 21.6L88.964 1.246h20.687l17.104 79.963zm-30.603 0L53.941 26.782l-8.71 46.277c-1.022 5.166-5.058 8.149-9.54 8.149H.493L0 78.886c7.226-1.568 15.436-4.097 20.41-6.803c3.044-1.653 3.912-3.098 4.912-7.026L41.819 1.245H63.68l33.516 79.963z" transform="matrix(1 0 0 -1 0 82.668)" /></svg>
                                    </div>}
                                    {card.card.brand === 'mastercard' && <div className="svgIcon">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="1.29em" height="1em" viewBox="0 0 256 199"><path d="M46.54 198.011V184.84c0-5.05-3.074-8.342-8.343-8.342c-2.634 0-5.488.878-7.464 3.732c-1.536-2.415-3.731-3.732-7.024-3.732c-2.196 0-4.39.658-6.147 3.073v-2.634h-4.61v21.074h4.61v-11.635c0-3.731 1.976-5.488 5.05-5.488c3.072 0 4.61 1.976 4.61 5.488v11.635h4.61v-11.635c0-3.731 2.194-5.488 5.048-5.488c3.074 0 4.61 1.976 4.61 5.488v11.635zm68.271-21.074h-7.463v-6.366h-4.61v6.366h-4.171v4.17h4.17v9.66c0 4.83 1.976 7.683 7.245 7.683c1.976 0 4.17-.658 5.708-1.536l-1.318-3.952c-1.317.878-2.853 1.098-3.951 1.098c-2.195 0-3.073-1.317-3.073-3.513v-9.44h7.463zm39.076-.44c-2.634 0-4.39 1.318-5.488 3.074v-2.634h-4.61v21.074h4.61v-11.854c0-3.512 1.536-5.488 4.39-5.488c.878 0 1.976.22 2.854.439l1.317-4.39c-.878-.22-2.195-.22-3.073-.22m-59.052 2.196c-2.196-1.537-5.269-2.195-8.562-2.195c-5.268 0-8.78 2.634-8.78 6.805c0 3.513 2.634 5.488 7.244 6.147l2.195.22c2.415.438 3.732 1.097 3.732 2.195c0 1.536-1.756 2.634-4.83 2.634s-5.488-1.098-7.025-2.195l-2.195 3.512c2.415 1.756 5.708 2.634 9 2.634c6.147 0 9.66-2.853 9.66-6.805c0-3.732-2.854-5.708-7.245-6.366l-2.195-.22c-1.976-.22-3.512-.658-3.512-1.975c0-1.537 1.536-2.415 3.951-2.415c2.635 0 5.269 1.097 6.586 1.756zm122.495-2.195c-2.635 0-4.391 1.317-5.489 3.073v-2.634h-4.61v21.074h4.61v-11.854c0-3.512 1.537-5.488 4.39-5.488c.879 0 1.977.22 2.855.439l1.317-4.39c-.878-.22-2.195-.22-3.073-.22m-58.833 10.976c0 6.366 4.39 10.976 11.196 10.976c3.073 0 5.268-.658 7.463-2.414l-2.195-3.732c-1.756 1.317-3.512 1.975-5.488 1.975c-3.732 0-6.366-2.634-6.366-6.805c0-3.951 2.634-6.586 6.366-6.805c1.976 0 3.732.658 5.488 1.976l2.195-3.732c-2.195-1.757-4.39-2.415-7.463-2.415c-6.806 0-11.196 4.61-11.196 10.976m42.588 0v-10.537h-4.61v2.634c-1.537-1.975-3.732-3.073-6.586-3.073c-5.927 0-10.537 4.61-10.537 10.976s4.61 10.976 10.537 10.976c3.073 0 5.269-1.097 6.586-3.073v2.634h4.61zm-16.904 0c0-3.732 2.415-6.805 6.366-6.805c3.732 0 6.367 2.854 6.367 6.805c0 3.732-2.635 6.805-6.367 6.805c-3.951-.22-6.366-3.073-6.366-6.805m-55.1-10.976c-6.147 0-10.538 4.39-10.538 10.976s4.39 10.976 10.757 10.976c3.073 0 6.147-.878 8.562-2.853l-2.196-3.293c-1.756 1.317-3.951 2.195-6.146 2.195c-2.854 0-5.708-1.317-6.367-5.05h15.587v-1.755c.22-6.806-3.732-11.196-9.66-11.196m0 3.951c2.853 0 4.83 1.757 5.268 5.05h-10.976c.439-2.854 2.415-5.05 5.708-5.05m114.372 7.025v-18.879h-4.61v10.976c-1.537-1.975-3.732-3.073-6.586-3.073c-5.927 0-10.537 4.61-10.537 10.976s4.61 10.976 10.537 10.976c3.074 0 5.269-1.097 6.586-3.073v2.634h4.61zm-16.903 0c0-3.732 2.414-6.805 6.366-6.805c3.732 0 6.366 2.854 6.366 6.805c0 3.732-2.634 6.805-6.366 6.805c-3.952-.22-6.366-3.073-6.366-6.805m-154.107 0v-10.537h-4.61v2.634c-1.537-1.975-3.732-3.073-6.586-3.073c-5.927 0-10.537 4.61-10.537 10.976s4.61 10.976 10.537 10.976c3.074 0 5.269-1.097 6.586-3.073v2.634h4.61zm-17.123 0c0-3.732 2.415-6.805 6.366-6.805c3.732 0 6.367 2.854 6.367 6.805c0 3.732-2.635 6.805-6.367 6.805c-3.951-.22-6.366-3.073-6.366-6.805" /><path fill="#ff5f00" d="M93.298 16.903h69.15v124.251h-69.15z" /><path fill="#eb001b" d="M97.689 79.029c0-25.245 11.854-47.637 30.074-62.126C114.373 6.366 97.47 0 79.03 0C35.343 0 0 35.343 0 79.029s35.343 79.029 79.029 79.029c18.44 0 35.343-6.366 48.734-16.904c-18.22-14.269-30.074-36.88-30.074-62.125" /><path fill="#f79e1b" d="M255.746 79.029c0 43.685-35.343 79.029-79.029 79.029c-18.44 0-35.343-6.366-48.734-16.904c18.44-14.488 30.075-36.88 30.075-62.125s-11.855-47.637-30.075-62.126C141.373 6.366 158.277 0 176.717 0c43.686 0 79.03 35.563 79.03 79.029" /></svg>
                                    </div>}
                                </div>
                                <div className="cardInfoContainer">
                                    <div className="cardTextContainer">
                                        <h2>{card.card.brand}... {card.card.last4}</h2>
                                        <p>Expires on: {card.card.exp_month}/{card.card.exp_year}</p>
                                    </div>
                                    {card.isDefault && <p className="defaultMethodText">Default</p>}
                                </div>

                                <div className="">
                                    <button className="openActions" onClick={() => {toggleActions(index)}}>
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                            <path d="M12 5V5.01M12 12V12.01M12 19V19.01M12 6C11.7348 6 11.4804 5.89464 11.2929 5.70711C11.1054 5.51957 11 5.26522 11 5C11 4.73478 11.1054 4.48043 11.2929 4.29289C11.4804 4.10536 11.7348 4 12 4C12.2652 4 12.5196 4.10536 12.7071 4.29289C12.8946 4.48043 13 4.73478 13 5C13 5.26522 12.8946 5.51957 12.7071 5.70711C12.5196 5.89464 12.2652 6 12 6ZM12 13C11.7348 13 11.4804 12.8946 11.2929 12.7071C11.1054 12.5196 11 12.2652 11 12C11 11.7348 11.1054 11.4804 11.2929 11.2929C11.4804 11.1054 11.7348 11 12 11C12.2652 11 12.5196 11.1054 12.7071 11.2929C12.8946 11.4804 13 11.7348 13 12C13 12.2652 12.8946 12.5196 12.7071 12.7071C12.5196 12.8946 12.2652 13 12 13ZM12 20C11.7348 20 11.4804 19.8946 11.2929 19.7071C11.1054 19.5196 11 19.2652 11 19C11 18.7348 11.1054 18.4804 11.2929 18.2929C11.4804 18.1054 11.7348 18 12 18C12.2652 18 12.5196 18.1054 12.7071 18.2929C12.8946 18.4804 13 18.7348 13 19C13 19.2652 12.8946 19.5196 12.7071 19.7071C12.5196 19.8946 12.2652 20 12 20Z" stroke="#090516" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                        </svg>
                                    </button>

                                    {openMenuIndex === index && (
                                        <div className="editItem">
                                            <button onClick={() => { handleSetPrimary(card.id) }}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 512 512"><rect width="416" height="320" x="48" y="96" fill="none" stroke={card.isDefault ? "grey" : "black"} stroke-linecap="round" stroke-linejoin="round" stroke-width="32" rx="56" ry="56" /><path fill="none" stroke={card.isDefault ? "grey" : "black"} stroke-linejoin="round" stroke-width="60" d="M48 192h416M128 300h48v20h-48z" /></svg>
                                                <p style={{color: card.isDefault ? 'grey' : 'black'}}>Set Default</p>
                                            </button>
                                            {/*<button >*/}
                                            {/*    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">*/}
                                            {/*        <path d="M8 4.00004H3C2.46957 4.00004 1.96086 4.21075 1.58579 4.58583C1.21071 4.9609 1 5.46961 1 6.00004V17C1 17.5305 1.21071 18.0392 1.58579 18.4143C1.96086 18.7893 2.46957 19 3 19H14C14.5304 19 15.0391 18.7893 15.4142 18.4143C15.7893 18.0392 16 17.5305 16 17V12M14.586 2.58604C14.7705 2.39502 14.9912 2.24266 15.2352 2.13784C15.4792 2.03302 15.7416 1.97785 16.0072 1.97554C16.2728 1.97323 16.5361 2.02384 16.7819 2.1244C17.0277 2.22496 17.251 2.37346 17.4388 2.56125C17.6266 2.74904 17.7751 2.97234 17.8756 3.21813C17.9762 3.46392 18.0268 3.72728 18.0245 3.99284C18.0222 4.2584 17.967 4.52084 17.8622 4.76485C17.7574 5.00886 17.605 5.22955 17.414 5.41404L8.828 14H6V11.172L14.586 2.58604Z" stroke="#090516" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />*/}
                                            {/*    </svg>*/}
                                            {/*    <p>Edit</p>*/}
                                            {/*</button>*/}
                                            <button onClick={() => { toggleDeleteConfirm(); setCardToDelete(card.id) }}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                                    <path d="M19 7L18.133 19.142C18.0971 19.6466 17.8713 20.1188 17.5011 20.4636C17.1309 20.8083 16.6439 21 16.138 21H7.862C7.35614 21 6.86907 20.8083 6.49889 20.4636C6.1287 20.1188 5.90292 19.6466 5.867 19.142L5 7M10 11V17M14 11V17M15 7V4C15 3.73478 14.8946 3.48043 14.7071 3.29289C14.5196 3.10536 14.2652 3 14 3H10C9.73478 3 9.48043 3.10536 9.29289 3.29289C9.10536 3.48043 9 3.73478 9 4V7M4 7H20" stroke="#090516" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                                </svg>
                                                <p>Delete</p>
                                            </button>
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))}
                    </div>

                    <button className="addPayMethod" onClick={() => {toggleNewPayMethod()}}>Add Payment Method</button>
                </div>

                <div className="setUpPaymentMethodContainer" style={{display: setupNewPayMethod ? 'block' : 'none'}}>
                    <h2>Set Up Payment Method</h2>
                    <p>Step {step}</p>
                    <div className="newPayMethodsNav">
                        {/*<button style={{ fontWeight: step === '1' ? 'bold' : 'normal' }} onClick={() => { changeStep('1') }}>Card Information</button>*/}
                        {/*<button style={{ fontWeight: step === '2' ? 'bold' : 'normal' }} onClick={() => { changeStep('2') }}>Billing Address</button>*/}
                        <label>Card details</label>
                    </div>

                    <div className="divider"></div>

                    <div className="formControl">
                        <CardElement
                            options={{
                                style: {
                                    base: {
                                        fontSize: '16px',
                                        color: '#424770',
                                        '::placeholder': {
                                            color: '#aab7c4',
                                        },
                                    },
                                    invalid: {
                                        color: '#9e2146',
                                    },
                                },
                            }}
                        />
                    </div>
                    <div className="controlBtns">
                        <button onClick={toggleNewPayMethod}>Cancel</button>
                        <button className="addCardBtn" onClick={addPaymentMethod}>Add Card</button>
                    </div>
                    
                </div>

                <div className="deletePayMethod" style={{ display: deleteConfirm ? 'block' : 'none' }}>
                    <button className="exit" onClick={() => { toggleDeleteConfirm() }}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M6 18L18 6M6 6L18 18" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                        </svg>
                    </button>
                    <svg xmlns="http://www.w3.org/2000/svg" width="48" height="54" viewBox="0 0 48 54" fill="none">
                        <path d="M42.666 13.6667L40.354 46.0453C40.2582 47.3909 39.6561 48.6502 38.669 49.5695C37.6818 50.4889 36.383 51 35.034 51H12.9647C11.6157 51 10.3169 50.4889 9.32971 49.5695C8.34256 48.6502 7.74046 47.3909 7.64468 46.0453L5.33268 13.6667M18.666 24.3333V40.3333M29.3327 24.3333V40.3333M31.9993 13.6667V5.66667C31.9993 4.95942 31.7184 4.28115 31.2183 3.78105C30.7182 3.28095 30.0399 3 29.3327 3H18.666C17.9588 3 17.2805 3.28095 16.7804 3.78105C16.2803 4.28115 15.9993 4.95942 15.9993 5.66667V13.6667M2.66602 13.6667H45.3327" stroke="black" stroke-width="5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    <h2>Are you sure you want to delete this payment method?</h2>
                    <p>This payment method will be permenantly deleted and shan't be used for future transactions.</p>
                    <div className="deleteBtns">
                        <button onClick={() => { toggleDeleteConfirm() }}>Cancel</button>
                        <button onClick={() => { handleDelete(cardToDelete) }}>Delete</button>
                    </div>
                </div>

                <div className="overlay" style={{ display: setupNewPayMethod ? 'block' : 'none' }}></div>
                <div className="overlay" style={{ display: deleteConfirm ? 'block' : 'none' }}></div>
            </div>
        </div>
    )
}

export default PaymentMethods;